import { registerPlugin } from '@capacitor/core';

export interface NativeDebugLogStatus {
  enabled: boolean;
}

export interface NativeDebugLogWriteOptions {
  level: 'log' | 'debug' | 'info' | 'warn' | 'error';
  message: string;
}

export interface NativeDebugLogPlugin {
  getStatus(): Promise<NativeDebugLogStatus>;
  write(options: NativeDebugLogWriteOptions): Promise<NativeDebugLogStatus>;
}

export const NativeDebugLog = registerPlugin<NativeDebugLogPlugin>('NativeDebugLog', {
  web: () => import('./nativeDebugLogWeb').then((module) => new module.NativeDebugLogWeb()),
});
